import { render } from "./CategoryView.vue?vue&type=template&id=0f44138c"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=0f44138c&lang=css"

import exportComponent from "E:\\project\\spiderx-gui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__